export default "__VITE_ASSET__6c689c13__"